module.exports = __webpack_public_path__ + "static/media/fa-brands-400.bcfcad6c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-brands-400.woff
// module id = 730
// module chunks = 0